<template>
  <!-- template for the modal component -->
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <v-card class="modal-container betSlipContainer" color="background">
          <v-btn elevation="0" fab color="error" small class="modal-default-button title" style="position:absolute"
            @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <h2 class="mt-4 betSlipItemName">{{ findBet.runnerNumber }}. {{ findBet.runnerName }}</h2>
          <h4 class="betSlipRaceName">{{ findBet.trackName }}</h4>
          <div style="margin:0 auto;text-align:center">
            <h1 class="betRunnerPrice d-inline">${{ findBet.odds }}</h1>
            <h3 class="betSlipType d-inline ml-2">{{ findBet.winPlc }}</h3>
          </div>
          <v-card color="background" class="mx-5">
            <div>
              <div v-if="!highDomKeyboard" class="row" slot="body" style="float:left;width:500px;">
                <v-switch v-model="keypad" label="Keypad"></v-switch>
                <div class="col-12">
                  <div v-if="keypad" style="width:60%;margin:0 auto;">
                    <SimpleKeyboardAMT @onChange="onChange" :input="stake" />
                  </div>
                  <div v-if="!keypad" class="row">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(1)">$1</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(2)">$2</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(5)">$5</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(10)">$10</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(20)">$20</v-btn>
                  </div>
                </div>
                <div v-if="!keypad" class="col-12">
                  <div class="row">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(50)">$50</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(100)">$100</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(200)">$200</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(500)">$500</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold white--text" width="60"
                      color="red" @click="stake = 0">Clear</v-btn>
                  </div>
                </div>
              </div>
              <div v-if="highDomKeyboard" class="row" slot="body" style="float:left;width:500px;">
                <v-switch v-model="keypad" label="Keypad"></v-switch>
                <div class="col-12">
                  <div v-if="keypad" style="width:60%;margin:0 auto;">
                    <SimpleKeyboardAMT @onChange="onChange" :input="stake" />
                  </div>
                  <div v-if="!keypad" class="row d-flex justify-center">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(100)">$100</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(200)">$200</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(500)">$500</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(1000)">$1000</v-btn>
                  </div>
                </div>
                <div v-if="!keypad" class="col-12">
                  <div class="row d-flex justify-center">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(2000)">$2000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(5000)">$5000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(10000)">$10000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold white--text" width="60"
                      color="red" @click="stake = 0">Clear</v-btn>
                  </div>
                </div>
              </div>
              <v-text-field type="number" autofocus pattern="[0-9]*" v-model="stake" :placeholder="prevStake"
                label="Stake" style="width:150px;" outlined class="float-left mt-5 mb-n15 display-1"></v-text-field>
              <v-text-field type="number" pattern="[0-9]*" v-model="profit" disabled label="Possible Payout"
                style="width:150px;" outlined class="float-right mt-5 display-1 mb-n15"></v-text-field>
            </div>
          </v-card>
          <v-btn elevation="0" x-large class="placeBetButton mb-3" @click="deleteBet(findBet), $emit('close')"
            color="error">
            <span class="display-1">Delete Bet</span>
          </v-btn>
          <v-btn elevation="0" :disabled="!stake" x-large class="placeBetButton" @click="addBet()" color="success">
            <span class="display-1">Edit Bet</span>
          </v-btn>
        </v-card>
      </div>
    </div>
  </transition>

  <!-- app -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SimpleKeyboardAMT from "./SimpleKeyboardAMT"
import { HIGHKEYBOARD } from '../common/constants'

export default {
  name: 'BetSlipEditor',
  data() {
    return {
      stake: null,
      value: 0,
      keypad: false
    }
  },
  props: {
    item: Object,
    editBetId: String
  },
  components: {
    SimpleKeyboardAMT
  },
  computed: {
    ...mapGetters(['getTerminalId', 'getBetSlip', 'getVenueName']),
    profit: function () {
      if (this.stake === null) {
        return this.findBet.odds * this.prevStake
      }
      return this.findBet.odds * this.stake
    },
    findBet() {
      let filterBetSlip = this.getBetSlip
      filterBetSlip = filterBetSlip.filter((item) => {
        return (item.selId === this.editBetId)
      })
      return filterBetSlip[0]
    },
    prevStake() {
      return this.findBet.stake
    },
    highDomKeyboard() {
      if (HIGHKEYBOARD[this.getVenueName]) return true
      return false
    },
  },
  methods: {
    ...mapActions(['loadEditedBet', 'deleteBet']),
    async addBet() {
      this.loadCircle = true,
        this.interval = setInterval(() => {
          if (this.value === 100) {
            return (this.value = 0)
          }
          this.value += 10
        }, 1000)
      this.loadEditedBet({
        runnerName: this.findBet.runnerName,
        runnerNumber: this.findBet.runnerNumber,
        raceName: this.findBet.raceName,
        winPlc: this.findBet.winPlc,
        selId: this.findBet.selId,
        odds: this.findBet.odds,
        stake: Number(this.stake)?.toFixed(2),
        trackName: this.findBet.trackName,
        trackCountry: this.findBet.trackCountry,
        trackNumber: this.findBet.trackNumber,
        meeting: this.findBet.meeting,
        startTime: this.findBet.startTime,
        raceId: this.findBet?.id,
      }),
        this.$emit('close');
    },
    addStake(amt) {
      this.stake = (parseFloat(this.stake || 0) + parseFloat(amt)).toString()
    },
    onChange(enteredAmt) {
      this.stake = enteredAmt
    },
  }
}
</script>

<style scoped>
.betSlipType {
  text-align: center;
  font-weight: 600;
  color: #00A500
}

.betRunnerPrice {
  text-align: center;
  font-size: 3em;
}

.placeBetButton {
  border-radius: 8px;
  width: 100%;
  padding: 12px;
  color: #fff;
  font-size: 1.8em;
  text-align: center;
  bottom: -50px;
  z-index: 200;
  position: relative;
  font-weight: 600;
  cursor: pointer;
}

.payoutTxt {
  float: right;
  font-size: 1.1em;
  margin-top: 5px;
}

.betSlipSpacer {
  height: 130px;
  background: #fff;
  width: 100%;
  margin-bottom: 30px;
  border-top: 1px solid #efefef;
  padding-top: 10px;
}

.betSlipItemName {
  text-align: center;
  font-size: 2.0em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.betSlipRaceName {
  text-align: center;
  font-weight: 600;
}

.spacerContainer {
  height: 40px;
  padding-top: 10px;
}

.addMultiButton {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  font-size: 1.1em;
  color: #333;
  width: 100%;
  padding: 10px;
  margin-top: 50px;
  text-align: center;
}

.unitStake {
  border: 1px solid #666;
  width: 100%;
  padding: 5px;
  font-size: 1.2em;
  font-weight: 500;
  background: #e6faff;
  color: #666;
  height: 1.8em;
  margin-top: 50px;
}

.betPriceButton {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  height: 3em;
  width: 17%;
  font-size: 1em;
  padding: 5px;
  text-align: center;
  margin: 7px 0 0 7px;
  line-height: 2.5em;
  font-weight: 600;
  color: #333;
  cursor: pointer;
}

.removeBorder {
  box-shadow: none;
  background-color: #ffffff;
  height: 3em;
  width: 18%;
  padding: 5px;
  text-align: center;
  margin: 5px 0 0 5px;
}

.modal-icon {
  margin-top: -80px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.betSlipContainer {
  width: 580px;
  margin: 0px auto;
  padding: 20px 30px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.betPriceButtonClear {
  background-color: #ffffff;
  height: 3em;
  width: 17%;
  font-size: 0.9em;
  padding: 5px;
  text-align: center;
  margin: 7px 0 0 7px;
  line-height: 2.5em;
  font-weight: 600;
  color: #333;
}

@media only screen and (max-width: 600px) {
  .modal-container {
    width: 90%;
    margin: 0px auto;
    padding: 20px 30px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .betPriceButton {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    height: 3em;
    width: 17%;
    font-size: 0.8em;
    padding: 5px;
    text-align: center;
    margin: 7px 0 0 7px;
    line-height: 2.5em;
    font-weight: 600;
    color: #333;
  }

  .betPriceButtonClear {
    background-color: #ffffff;
    height: 3em;
    width: 17%;
    font-size: 0.7em;
    padding: 5px;
    text-align: center;
    margin: 7px 0 0 7px;
    line-height: 2.5em;
    font-weight: 600;
    color: #333;
  }

  .modal-default-button {
    display: inline-block;
  }

  .raceTypeIconSlip {
    height: 80px;
    width: 80px;
    border-radius: 80px;
    background: #fff;
    margin: 0 auto;
    top: -80px;
    z-index: 200;
    position: relative;
    border: 6px solid #000;
    text-align: center;
  }
}

.raceTypeIconSlip {
  height: 80px;
  width: 80px;
  border-radius: 80px;
  background: #fff;
  margin: 0 auto;
  top: -60px;
  z-index: 200;
  position: relative;
  border: 6px solid #000;
  text-align: center;
}

.modal-default-button {
  float: left;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}</style>
